module.exports = __webpack_public_path__ + "img/image-block-1.78ad02bb.png";